module.exports = __webpack_public_path__ + "img/questionmark.cafc75b5.svg";